module.exports = __webpack_public_path__ + "static/media/carrot.506c9e6a.svg";